exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1,h2, h3{\n     font-weight:bold !important;\n}\n", ""]);

// exports
